

// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Home, User, ClipboardList } from "lucide-react";

// const BottomNav = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const navItems = [
//     { 
//       icon: Home, 
//       label: "Home", 
//       path: "/home",
//       activeColor: "bg-blue-500"
//     },
//     { 
//       icon: ClipboardList, 
//       label: "Survey", 
//       path: "/survey",
//       activeColor: "bg-green-500"
//     },
//     { 
//       icon: User, 
//       label: "Profile", 
//       path: "/profile",
//       activeColor: "bg-purple-500"
//     },
//   ];

//   // Simplified active check
//   const isRouteActive = (path) => {
//     if (path === "/home") {
//       return location.pathname === "/home";
//     }
//     if (path === "/survey") {
//       // Active on main survey page only (not sections)
//       return location.pathname === "/survey";
//     }
//     if (path === "/profile") {
//       return location.pathname === "/profile";
//     }
//     return location.pathname === path;
//   };

//   return (
//     <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
//       <div className="flex justify-around items-center h-16">
//         {navItems.map(({ icon: Icon, label, path, activeColor }) => {
//           const active = isRouteActive(path);
          
//           return (
//             <button
//               key={path}
//               onClick={() => navigate(path)}
//               className={`flex flex-col items-center justify-center flex-1 h-full ${
//                 active ? "text-blue-600" : "text-gray-500"
//               }`}
//             >
//               <div className={`relative p-2 rounded-lg ${active ? activeColor : ""}`}>
//                 <Icon size={24} className={active ? "text-white" : ""} />
//                 {active && (
//                   <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></span>
//                 )}
//               </div>
//               <span className={`text-xs mt-1 ${active ? "font-semibold" : ""}`}>
//                 {label}
//               </span>
//             </button>
//           );
//         })}
//       </div>
//     </nav>
//   );
// };

// export default BottomNav;


import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, User, ClipboardList } from "lucide-react";
import { useLanguage } from "../context/LanguageContext"; // Correct import path

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const navItems = [
    { 
      icon: Home, 
      label: t.global.home, 
      path: "/home",
      activeColor: "bg-blue-500"
    },
    { 
      icon: ClipboardList, 
      label: t.global.survey, 
      path: "/survey",
      activeColor: "bg-green-500"
    },
    { 
      icon: User, 
      label: t.global.profile, 
      path: "/profile",
      activeColor: "bg-purple-500"
    },
  ];

  const isRouteActive = (path) => {
    if (path === "/home") {
      return location.pathname === "/home";
    }
    if (path === "/survey") {
      return location.pathname === "/survey";
    }
    if (path === "/profile") {
      return location.pathname === "/profile";
    }
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex justify-around items-center h-16">
        {navItems.map(({ icon: Icon, label, path, activeColor }) => {
          const active = isRouteActive(path);
          
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-all duration-200 ${
                active ? "text-blue-600" : "text-gray-500"
              }`}
            >
              <div className={`relative p-2 rounded-lg transition-all duration-200 ${active ? activeColor : ""}`}>
                <Icon size={24} className={active ? "text-white" : ""} />
                {active && (
                  <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                )}
              </div>
              <span className={`text-xs mt-1 transition-all duration-200 ${active ? "font-semibold scale-105" : ""}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;